import React from "react";
import { Card, Tag } from "antd";
import { useGetLatestRequestsQuery } from "../../../Redux/service/Consultant/ConsultantDashboard";
import Loader from "../../Helpers/Loader/Loader";
import trans from "../../../utils";
import AntdTable from "../../antd/Table/Table";
import { formatDateString } from "../../../JsHelpers/DateFormat";

export default function ConsultantRequestsTable({ refreshKey }) {
  const { data: requestsData, isLoading } = useGetLatestRequestsQuery(
    { limit: 10, refreshKey },
    { refetchOnMountOrArgChange: true }
  );

  if (isLoading) {
    return <Loader />;
  }

  const requests = requestsData?.data || requestsData || [];

  const columns = [
    {
      title: trans("Request Code"),
      dataIndex: "requestCode",
      width: 150,
      render: (value) => <span className="table-element-name ps-0">{value || "-"}</span>,
    },
    {
      title: trans("Service Type"),
      dataIndex: "serviceType",
      width: 150,
      render: (value) => <span>{value || "-"}</span>,
    },
    {
      title: trans("Requester (Customer)"),
      dataIndex: "user",
      width: 200,
      render: (value) => <span>{value?.name || "-"}</span>,
    },
    {
      title: trans("Status"),
      dataIndex: "status",
      width: 120,
      render: (value) => {
        const colorMap = {
          pending: "orange",
          approved: "green",
          rejected: "red",
          in_progress: "blue",
          completed: "green",
          cancelled: "default",
        };
        return (
          <Tag color={colorMap[value?.toLowerCase()] || "default"}>
            {value || "-"}
          </Tag>
        );
      },
    },
    {
      title: trans("Priority"),
      dataIndex: "priority",
      width: 100,
      render: (value) => {
        const colorMap = {
          high: "red",
          medium: "orange",
          low: "green",
        };
        return (
          <Tag color={colorMap[value?.toLowerCase()] || "default"}>
            {value || "-"}
          </Tag>
        );
      },
    },
    {
      title: trans("Created At"),
      dataIndex: "createdAt",
      width: 180,
      render: (value) => (
        <span className="table-element-date">
          {value ? formatDateString(value) : "-"}
        </span>
      ),
    },
    {
      title: trans("Preferred Date"),
      dataIndex: "preferredTime",
      width: 180,
      render: (value) => (
        <span className="table-element-date">
          {value ? formatDateString(value) : "-"}
        </span>
      ),
    },
  ];

  return (
    <Card
      title={trans("Latest Requests")}
      style={{
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <div className="bg-white-rounded-top mt-3 table-parent">
        <AntdTable
          columns={columns}
          dataSource={requests}
          loading={isLoading}
          pageSize={10}
          totalItems={requests.length}
          currentPage={1}
          scrollY={350}
          empty
        />
      </div>
    </Card>
  );
}

